import { Commodity } from '@/generated/gql/graphql';

export enum CommodityDataGridField {
  EXTERNAL_ID = 'externalId',
  NAME = 'name',
  DESCRIPTION = 'description',
  SUPPLIER_COUNT = 'supplierCount',
  CONTRACT_COUNT = 'contractCount',
  DELIVERY_ON_TIME_PERCENTAGE = 'deliveryOnTimePercentage',
  CORRECT_ORDER_PERCENTAGE = 'correctOrderPercentage',
  DEVIATING_PRICE_PERCENTAGE = 'deviatingPricePercentage',
  DEVIATING_QUANTITY_PERCENTAGE = 'deviatingQuantityPercentage',
  LEAD_TIME = 'leadTime',
  ORDER_COUNT = 'orderCount',
  ORDER_VOLUME_YEAR = 'orderVolumeYear',
  ORDER_COUNT_YEAR = 'orderCountYear',
  ORDER_VOLUME = 'orderVolume',
  PRIMARY_COMMODITY_GROUP = 'primaryCommodityGroup',
  COMMODITY_GROUP_LIST = 'commodityGroupList',
  COMMODITY_GROUP_COUNT = 'commodityGroupCount',
  LINKS = 'links',
}

export enum CommodityDataGridColumnGroup {
  SUPPLIER = 'supplier',
  CONTRACT = 'contract',
  ORDER = 'order',
  COMMODITY = 'commodity',
  PERFORMANCE = 'performance',
}

export type CommodityDataGridRow = Commodity;
